import React from 'react';
import { path, prop } from 'ramda';
import { useDeviceSelector } from 'js/store/hooks';
import Range from 'js/components/common/Range/Range';
import { FeatureIcon } from 'js/components/common/Game/FeatureIcons';
import { usePortletDispatch, usePortletSelector, usePortletTranslations } from 'js/components/system/Portlet';

import Info from './Info';
import { VOLATILITY } from '../../constants';
import { setFilterVolatilityAction } from '../actions';

import style from './index.scss';

export const Volatility = ({ className = '' }) => {
    const isDesktop = useDeviceSelector(prop('isDesktop'));
    const selectedVolatility = usePortletSelector(path(['filters', 'selectedVolatility']));
    const rangeValue = VOLATILITY.indexOf(selectedVolatility) !== -1
        ? VOLATILITY.indexOf(selectedVolatility) + 1
        : 0;
    const t = usePortletTranslations();
    const dispatch = usePortletDispatch();

    const onRangeChange = ({ target: { value } }) => {
        dispatch(setFilterVolatilityAction(VOLATILITY[Number(value) - 1]));
    };

    return (
        <div className={`${style.container} ${className}`}>
            <div className={style.rangeContainer}>
                <FeatureIcon type={'volatility'} value={selectedVolatility || 'off'} className={style.label} />
                <Range
                    min={0}
                    max={4}
                    step={1}
                    defaultValue={rangeValue}
                    onChange={onRangeChange}
                    className={style.range}
                    title={isDesktop ? t('payOutScore.title') : ''}
                    colorsMap={{
                        1: 'green',
                        2: 'yellow',
                        3: 'orange',
                        4: 'red'
                    }}
                />
                <FeatureIcon type={'volatility'} value={VOLATILITY[3]} className={style.label} />
            </div>
            <div className={style.toggleContainer}>
                {!isDesktop && <b>{t('payOutScore.title')}</b>}
                <Info />
            </div>
        </div>
    );
};

export default Volatility;
